import Chart from 'chart.js/auto';

const BatteryOnlineOfflineChart = {
  chart: null,

  mounted() {
    console.log('BatteryOnlineOfflineChart mounted');
    this.initChart();
  },

  updated() {
    console.log('BatteryOnlineOfflineChart updated');
    this.updateChart();
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },

  initChart() {
    try {
      const ctx = this.el.getContext('2d');
      
      const faultyOnline = parseInt(this.el.dataset.faultyOnline) || 0;
      const faultyOffline = parseInt(this.el.dataset.faultyOffline) || 0;
      const eolOnline = parseInt(this.el.dataset.eolOnline) || 0;
      const eolOffline = parseInt(this.el.dataset.eolOffline) || 0;

      const totalDevices = faultyOnline + faultyOffline + eolOnline + eolOffline;

      if (totalDevices === 0) {
        console.log('No data for battery online/offline chart');
        return;
      }

      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Faulty Battery', 'End of Life'],
          datasets: [
            {
              label: 'Online',
              data: [faultyOnline, eolOnline],
              backgroundColor: '#10B981',
              borderColor: '#059669',
              borderWidth: 2,
              borderRadius: 6,
              hoverBackgroundColor: '#059669',
            },
            {
              label: 'Offline',
              data: [faultyOffline, eolOffline],
              backgroundColor: '#EF4444',
              borderColor: '#DC2626',
              borderWidth: 2,
              borderRadius: 6,
              hoverBackgroundColor: '#DC2626',
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false,
          },
          scales: {
            x: {
              stacked: false,
              grid: {
                display: false,
              },
              ticks: {
                color: '#6B7280',
                font: {
                  size: 12,
                  weight: '500'
                }
              }
            },
            y: {
              stacked: false,
              beginAtZero: true,
              grid: {
                color: '#F3F4F6',
                drawBorder: false,
              },
              ticks: {
                color: '#6B7280',
                font: {
                  size: 12
                },
                callback: function(value) {
                  return value.toLocaleString();
                }
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: 'top',
              align: 'end',
              labels: {
                color: '#374151',
                font: { 
                  size: 13,
                  weight: '500'
                },
                padding: 15,
                usePointStyle: true,
                pointStyle: 'circle'
              }
            },
            tooltip: {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              titleColor: '#fff',
              bodyColor: '#fff',
              padding: 12,
              cornerRadius: 8,
              displayColors: true,
              callbacks: {
                label: function(context) {
                  const label = context.dataset.label || '';
                  const value = context.parsed.y;
                  return `${label}: ${value.toLocaleString()}`;
                },
                footer: function(tooltipItems) {
                  let total = 0;
                  tooltipItems.forEach(function(tooltipItem) {
                    total += tooltipItem.parsed.y;
                  });
                  return `Total: ${total.toLocaleString()}`;
                }
              }
            }
          }
        }
      });

      console.log('BatteryOnlineOfflineChart initialized successfully');
    } catch (error) {
      console.error('Error initializing BatteryOnlineOfflineChart:', error);
    }
  },

  updateChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.initChart();
  }
};

export default BatteryOnlineOfflineChart;